import React, { useState, useEffect } from "react";
import "react-calendar/dist/Calendar.css";
import { Email } from "../../../assets/Images";
import ScheduleBg from "../../../assets/Images/scheduleBg.png";
import { DatePicker } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { ApiCall } from "../../../Services/apis";
import { setLoader } from "../../../Redux/Actions/GeneralActions";
import moment from "moment";
import "./Schedule.scss";
import Swal from "sweetalert2";
const Schedule = ({ data, setData }) => {
  const [selected, setSelected] = useState(false);
  const [load, setLoad] = useState(true);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.userToken);
  const [slots, setSlots] = useState([]);
  const range = (start, end) => {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  };

  const getTodaySloats = async (date) => {
    dispatch(setLoader(true));
    try {
      const res = await ApiCall({
        route: `doctor/timeslots_by_doctor_id/${data?.doctor_id}&${date}'`,
        verb: "get",
        token: token,
      });

      // we are passing disease id and date for booking
      console.log("DATA", data);
      // const res = await ApiCall({
      //   route: `doctor/all_doctors_timeslots?date=${date}`,
      //   verb: "get",
      //   token: token,
      // });
      // console.log("Doctors all time slots", res);

      if (res?.status == "200") {
        console.log("response", res?.response);
        setSlots(res?.response?.timeslots);
        // setSlots(res?.response?.data);
        dispatch(setLoader(false));
      } else {
        console.log("error", res.response);
        dispatch(setLoader(false));
      }
    } catch (e) {
      console.log("saga login error -- ", e.toString());
    }
  };

  const onChange = (e) => {
    const selectedDate = e.target.value;
    setData({ ...data, appointment_date: selectedDate });
    getTodaySloats(selectedDate);
  };

  useEffect(() => {
    const currentDate = moment().format("YYYY-MM-DD");
    setData({ ...data, appointment_date: currentDate });
    getTodaySloats(currentDate);
  }, []);

  console.log("dataaaa", data?.schedule);

  return (
    <>
      <div className="four-step"></div>
      <div className="w-[100%] md:flex justify-between personal-bgg">
        <div className="md:w-[50%] ">
          <div className="md:pl-[120px] pl-[20px] personal mt-[60px]">
            <h1>Schedule</h1>
            {/* <p className="md:pr-[50%] pr-[20px]">
              For safety reasons, the patient must be present to answer personal
              health questions. A parent or legal guardian must be present with
              a minor at all times.
            </p>
            <div className="flex mt-[40px] border-b">
              <h6>Email reminders</h6>
              <Email className=" ml-[10px]" />
            </div> */}
          </div>
          {/* <img src={ScheduleBg} className="md:block hidden absolute bottom-0" /> */}
        </div>
        <div className="md:w-[50%] md:pr-[74px] h-[400px] md:pl-[0px] pr-[20px] pl-[20px] mt-[10px]">
          <h1 className="schedule-heading">Select Appointment Date</h1>
          <div className="mb-[10px] w-[100%] ">
            <input
              type="date"
              onChange={onChange}
              defaultValue={moment().format("YYYY-MM-DD")}
              min={moment().subtract(1, "day").format("YYYY-MM-DD")}
              style={{
                marginTop: "10px",
                width: "100%",
                height: "45px",
                borderRadius: "10px",
                padding: "10px",
                border: "1px solid #d9d9d9",
              }}
              placeholder="Online Appointment Date"
            />
          </div>
          <h1 className="schedule-heading">Preferred Time Slot</h1>
          <div className=" mt-[15px]  md:mb-[0px] mb-[10px]">
            <div class="overflow-y-auto h-56">
              {load ? (
                <>
                  {slots?.length > 0 ? (
                    <>
                      {slots.map((item) => {
                        console.log("single slot", item?.status);
                        const isBooked = item?.status;
                        const isValidTime = moment().diff(
                          item?.start_time,
                          "minutes"
                        );
                        return (
                          <button
                            className={
                              isValidTime > 0
                                ? `notValidSlot`
                                : // isBooked !="open" ? `slotAlreadyBooked` :
                                data?.schedule?.end_time == item?.end_time &&
                                  data?.schedule?.start_time ==
                                    item?.start_time &&
                                  data?.schedule?.date == item?.date
                                ? `selected-time-slot mr-[10px] mb-[10px]`
                                : `time-slot-btn mr-[8px] mb-[10px]`
                            }
                            onClick={() => {
                              isValidTime < 0
                                ? // isBooked == "open" ?
                                  setData({ ...data, schedule: item })
                                : // Swal.fire({
                                  //   title:"This Slot is already booking"
                                  // }):
                                  Swal.fire({
                                    title: "This Slot time has gone.",
                                  });
                            }}
                          >
                            {moment(item?.start_time).format("hh-mm A") + "  "}
                            to
                            {"  " + moment(item?.end_time).format("hh-mm A")}
                          </button>
                        );
                      })}
                    </>
                  ) : (
                    <center>
                      <p>No timeslots available for the current day</p>
                    </center>
                  )}
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Schedule;
